import { formatDistanceToNow, Locale } from 'date-fns';
import { enUS, ru, tr } from 'date-fns/locale';

function getLocale(): Locale {
  const lang = navigator.language.toLowerCase();

  return lang.startsWith('ru') ? ru : lang.startsWith('tr') ? tr : enUS;
}

export function createdAtAgo(date: string | number | Date): string {
  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: getLocale(),
  });
}
